module.exports = __webpack_public_path__ + "static/media/bloodFull.6235f8ce.svg";